import "intersection-observer";
import Headroom from "headroom.js";
import sal from "sal.js";
import GLightbox from "glightbox";
import "./swiper.js";
import * as bootstrap from "bootstrap";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

flatpickr(".flatPicker", {
  locale: "en",
});

// loadClass
const theApp = document.getElementById("theApp");
theApp.classList.add("is-loaded");

// Sticky Header
const theHeader = document.getElementById("theHeader");
if (theHeader) {
  var headroom = new Headroom(theHeader, {
    offset: 100,
    classes: {
      initial: "is-sticky",
      // when scrolling up
      pinned: "is-pinned",
      // when scrolling down
      unpinned: "is-unpinned",
      // when above offset
      top: "is-top",
      // when below offset
      notTop: "is-not-top",
      // when at bottom of scoll area
      bottom: "is-bottom",
      // when not at bottom of scroll area
      notBottom: "is-not-bottom",
    },
  });
  headroom.init();
}

// Sal.js
sal({
  threshold: 0.1,
  once: true,
});

// #navOverlay
const navOverlay = document.querySelectorAll(".navOverlay")[0];
const navOverlayClose = document.querySelectorAll(".navOverlay-close");
const navOverlayOpen = document.querySelectorAll(".navOverlay-open");
if (navOverlayClose && navOverlay) {
  navOverlayClose.forEach((el) => {
    el.addEventListener("click", (event) => {
      navOverlay.classList.remove("is-active");
    });
  });
}
if (navOverlayOpen && navOverlay) {
  navOverlayOpen.forEach((el) => {
    el.addEventListener("click", (event) => {
      if (navOverlay.classList.contains("is-active")) {
        navOverlay.classList.remove("is-active");
        navOverlayOpen[0].classList.remove("is-active");
      } else {
        navOverlay.classList.add("is-active");
        navOverlayOpen[0].classList.add("is-active");
      }
    });
  });
}

// LazyLoad Images
window.addEventListener("load", (event) => {
  // Observer
  const inViewElms = document.querySelectorAll(".inViewJs");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(
      (entry) => {
        const lazyImage = entry.target.querySelector("img[data-src]");
        if (entry.intersectionRatio > 0) {
          lazyImage.src = lazyImage.dataset.src;

          lazyImage.onload = function () {
            entry.target.classList.add("inViewJs-active");
            observer.unobserve(entry.target);
          };
        } else {
          // console.log("out of view");
          // entry.target.classList.remove("inViewJs-active");
        }
      },
      { rootMargin: "0px 0px 100px 0px" }
    );
  });

  inViewElms.forEach((elm) => {
    observer.observe(elm);
  });
});



document.addEventListener('DOMContentLoaded', () => {
  const accordionItems = document.querySelectorAll('.faq-item');

  accordionItems.forEach((item) => {
      const button = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      const heading = item.querySelector('.faq-question-heading'); 

      button.addEventListener('click', () => {
          const isActive = item.classList.contains('is-active');
          const currentlyActiveItem = document.querySelector('.faq-item.is-active');

          if (currentlyActiveItem && currentlyActiveItem !== item) {
              currentlyActiveItem.classList.remove('is-active');
              currentlyActiveItem.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
          }


          item.classList.toggle('is-active');
          button.setAttribute('aria-expanded', !isActive);

      });

      if (heading && heading !== button) {
           heading.addEventListener('click', (e) => {
               
               if (e.target !== button && !button.contains(e.target)) {
                  button.click(); 
               }
           });
           heading.style.cursor = 'pointer'; 
      }


  });
});


document.addEventListener('DOMContentLoaded', () => {
  const playButtonTrigger = document.getElementById('playVideoButtonTrigger'); 
  const videoModal = document.getElementById('videoModal');
  const heroVideo = document.getElementById('heroVideo');
  const closeVideoModalButton = document.getElementById('closeVideoModal');


  if (playButtonTrigger) {
      playButtonTrigger.addEventListener('click', () => {
          videoModal.style.display = "flex";
          heroVideo.play(); 
      });
  }


  if (closeVideoModalButton) {
      closeVideoModalButton.addEventListener('click', () => {
          videoModal.style.display = "none"; 
          heroVideo.pause(); 
          heroVideo.currentTime = 0; 
      });
  }


  window.addEventListener('click', (event) => {
      if (event.target === videoModal) { 
          videoModal.style.display = "none";
          heroVideo.pause();
          heroVideo.currentTime = 0; 
      }
  });


  document.addEventListener('keydown', (event) => {
      if (event.key === "Escape" && videoModal.style.display === "flex") {
          videoModal.style.display = "none";
          heroVideo.pause();
          heroVideo.currentTime = 0; 
      }
  });
});
